export default __webpack_public_path__ + "static/media/kitchen5-beforeE-768w.62caa05f.png";